import i18n from '@/config/i18n'
import _ from 'lodash'

/**
 * @param value Enum値
 * @param enumName Enum名
 */
type Formatter = (enumValue: string, enumName: string) => string

const formatEnum: Formatter = (value, enumName) => {
  const key = `enums.${_.camelCase(enumName)}.${_.camelCase(value)}`
  return i18n.te(key) ? i18n.tc(key) : i18n.tc(`enums.unknown`)
}

export default formatEnum
